module.exports = __webpack_public_path__ + "static/10-dfd394fde24d914417c87354868da6eb.jpg";